async function getBroadcastDate(date) {
	return await fetch(`/schedule/${date}`, {
		method: 'POST',
	})
		.then((res) => res.json())
		.catch((err) => err.json())
}

export async function renderTVShows(slide) {
	const date = slide.getAttribute('data-date')
	const broadcastDays = await getBroadcastDate(date)
	const { schedule } = broadcastDays
	const scheduleList = document.querySelector('.section--schedule-detail .js-schedule-list')

	document.querySelectorAll('.section--schedule-detail .show').forEach((show) => show.remove())

	schedule.forEach((program) => {
		const broadcastItem = document.createElement('div')
		broadcastItem.classList.add('show', 'show--link')
		broadcastItem.innerHTML = `
          <div class="show__date">
            <div class="show__time">${program.time}</div>
          </div>
          <div class="show__content">
            <div class="show__title">${program.telecast.title}</div>
          </div>
          <div class="show__data">
            <div class="show__age">(${program.telecast.ageRating}+)</div>
          </div>`
		scheduleList.append(broadcastItem)
	})
}

export async function renderTVSchedule(slide, dependentSlider, removeSlides = false) {
	const date = slide.getAttribute('data-date')
	const broadcastDays = await getBroadcastDate(date)
	const { schedule } = broadcastDays

	if (removeSlides) {
		dependentSlider.removeAllSlides()
	}

	if (schedule) {
		schedule.forEach((day) => {
			const broadcastItem = `
            <div class="carousel__item item swiper-slide" data-time="${day.time}">
              <div class="item__content">
                <div class="item__time">${day.time}</div>
                <div class="item__title">${day.telecast.title}</div>
              </div>
            <div>`
			dependentSlider.appendSlide(broadcastItem)
		})
	} else {
		dependentSlider.removeAllSlides()
		const broadcastItem = `
    Расписание на этот день еще недоступно`
		dependentSlider.appendSlide(broadcastItem)
	}
}
